import { useTranslation } from 'react-i18next';
import { Box, withStyles } from 'vopay';
import { Card, Title } from 'UI';
import TransferForm from './TransferForm';
import TransferFormActions from './TransferFormActions';
import useTransferForm from './useTransferForm';
import { TransferFormValues } from './useTransferFormConfig';
import styles from './TransferPage.module.scss';

const cn = withStyles(styles);

/** The two-column fields; Notes sits full-width below them. */
const GRID_FIELDS: (keyof TransferFormValues)[] = [
  'TransferTypeID',
  'DebitorAccountID',
  'RecipientAccountID',
  'Currency',
  'Amount',
  'ClientReferenceNumber',
];

/** The standalone entry point to the transfer flow, reached from the Account Transfer nav item. */
export default function TransferPage() {
  const { t } = useTranslation('translations', { keyPrefix: 'PartnerAccountTransfer' });
  const flow = useTransferForm({ isActive: true });

  return (
    <div className={cn('pageContainer')}>
      <Box flx="col" gap="md">
        <Title level="1">{t('pageTitle', { defaultValue: 'Account Transfer' })}</Title>

        <div className={cn('body')}>
          <TransferForm isReviewing={flow.isReviewing} onSubmit={flow.ctx.handleSubmit}>
            <Card className={cn('sectionCard')}>
              <Title level="4">{t('sectionTitle', { defaultValue: 'Transfer Information' })}</Title>
              <div className={cn('grid')}>{flow.renderFormElements(GRID_FIELDS)}</div>
              {flow.renderFormElements(['Notes'])}
            </Card>
          </TransferForm>

          <TransferFormActions flow={flow} />
        </div>
      </Box>
    </div>
  );
}
